(function(){
  const SYLLABUS = [
    {s:'history', t:'Indus Valley Civilization'},
    {s:'history', t:'Vedic Period & Literature'},
    {s:'history', t:'Mahajanapadas & Buddhism'},
    {s:'history', t:'Mauryan Empire & Ashoka'},
    {s:'history', t:'Post-Mauryan Period'},
    {s:'history', t:'Gupta Empire — Golden Age'},
    {s:'history', t:'South Indian Kingdoms'},
    {s:'history', t:'Bhakti Movement'},
    {s:'history', t:'Delhi Sultanate'},
    {s:'history', t:'Vijayanagara Empire'},
    {s:'history', t:'Mughal Empire — Akbar'},
    {s:'history', t:'Mughal Empire — Aurangzeb'},
    {s:'history', t:'Sufi Movement'},
    {s:'history', t:'Maratha Empire'},
    {s:'history', t:'British East India Company'},
    {s:'history', t:'Revolt of 1857'},
    {s:'history', t:'Social Reform Movements'},
    {s:'history', t:'Indian National Congress'},
    {s:'history', t:'Gandhi & Non-Cooperation'},
    {s:'history', t:'Civil Disobedience Movement'},
    {s:'history', t:'Quit India Movement'},
    {s:'history', t:'Independence & Partition'},
    {s:'history', t:'Art & Architecture'},
    {s:'history', t:'World History — Revolutions'},
    {s:'geography', t:"Earth's Interior & Structure"},
    {s:'geography', t:'Geomorphology Basics'},
    {s:'geography', t:'Rocks & Landforms'},
    {s:'geography', t:'Atmosphere & Climatology'},
    {s:'geography', t:'Monsoon System'},
    {s:'geography', t:'Oceans & Ocean Currents'},
    {s:'geography', t:'Indian Physical Features'},
    {s:'geography', t:'Himalayas & Northern Plains'},
    {s:'geography', t:'Peninsular Plateau & Coasts'},
    {s:'geography', t:'Himalayan Rivers'},
    {s:'geography', t:'Peninsular Rivers'},
    {s:'geography', t:'Natural Vegetation & Soil'},
    {s:'geography', t:'Wildlife & Biosphere'},
    {s:'geography', t:'Agriculture — Crops & Types'},
    {s:'geography', t:'Minerals & Energy Resources'},
    {s:'geography', t:'Industries & Manufacturing'},
    {s:'geography', t:'Transport & Communication'},
    {s:'geography', t:'Population & Urbanisation'},
    {s:'geography', t:'World Physical Geography'},
    {s:'geography', t:'Economic & Political Geography'},
    {s:'polity', t:'Constitution — Making & Preamble'},
    {s:'polity', t:'Citizenship & Rights'},
    {s:'polity', t:'Fundamental Rights — Part I'},
    {s:'polity', t:'Fundamental Rights — Part II'},
    {s:'polity', t:'Directive Principles & Duties'},
    {s:'polity', t:'Parliament — Structure'},
    {s:'polity', t:'Parliament — Lok Sabha'},
    {s:'polity', t:'Parliament — Rajya Sabha'},
    {s:'polity', t:'Parliamentary Procedures'},
    {s:'polity', t:'President & Vice President'},
    {s:'polity', t:'Prime Minister & Cabinet'},
    {s:'polity', t:'Supreme Court of India'},
    {s:'polity', t:'High Courts & Subordinate Courts'},
    {s:'polity', t:'State Government'},
    {s:'polity', t:'Local Self Government'},
    {s:'polity', t:'Emergency Provisions'},
    {s:'polity', t:'Centre-State Relations'},
    {s:'polity', t:'Constitutional Bodies'},
    {s:'polity', t:'Statutory Bodies & Tribunals'},
    {s:'economy', t:'Economics — Basic Concepts'},
    {s:'economy', t:'National Income & GDP'},
    {s:'economy', t:'Money & Banking System'},
    {s:'economy', t:'Reserve Bank of India'},
    {s:'economy', t:'Monetary Policy'},
    {s:'economy', t:'Fiscal Policy & Budget'},
    {s:'economy', t:'Direct Taxes'},
    {s:'economy', t:'GST & Indirect Taxes'},
    {s:'economy', t:'External Sector & Trade'},
    {s:'economy', t:'FDI & Capital Markets'},
    {s:'economy', t:'Agriculture & Food Security'},
    {s:'economy', t:'Industrial Policy'},
    {s:'economy', t:'Infrastructure — Energy'},
    {s:'economy', t:'Poverty & Employment'},
    {s:'economy', t:'Social Sector Schemes'},
    {s:'economy', t:'Economic Reforms & Indices'},
    {s:'science', t:'Physics — Motion & Laws'},
    {s:'science', t:'Physics — Optics & Waves'},
    {s:'science', t:'Physics — Electricity & Magnetism'},
    {s:'science', t:'Chemistry — Elements & Bonds'},
    {s:'science', t:'Chemistry — Acids & Reactions'},
    {s:'science', t:'Biology — Cell & Life Processes'},
    {s:'science', t:'Biology — Human Body Systems'},
    {s:'science', t:'Biology — Genetics & Evolution'},
    {s:'science', t:'Biotechnology & GMOs'},
    {s:'science', t:'Space Technology & ISRO'},
    {s:'science', t:'Defence Technology'},
    {s:'science', t:'Nuclear Technology'},
    {s:'science', t:'IT, AI & Computers'},
    {s:'science', t:'Nanotechnology & New Tech'},
    {s:'environment', t:'Ecology & Ecosystem'},
    {s:'environment', t:'Food Chains & Energy Flow'},
    {s:'environment', t:'Biodiversity — Types & Value'},
    {s:'environment', t:'Biodiversity Conservation'},
    {s:'environment', t:'Climate Change & IPCC'},
    {s:'environment', t:'Global Warming & Mitigation'},
    {s:'environment', t:'Air & Water Pollution'},
    {s:'environment', t:'Soil & Noise Pollution'},
    {s:'environment', t:'Environmental Laws (India)'},
    {s:'environment', t:'International Agreements'},
    {s:'environment', t:'Protected Areas & IUCN'},
    {s:'environment', t:'Renewable Energy'},
    {s:'environment', t:'Natural Disasters'},
    {s:'environment', t:'Sustainable Development Goals'},
    {s:'current', t:'Government Schemes 2024–25'},
    {s:'current', t:'Economic Policy Developments'},
    {s:'current', t:'India — Foreign Relations'},
    {s:'current', t:'India — Defence & Security'},
    {s:'current', t:'Science & Tech News'},
    {s:'current', t:'Environment & Climate News'},
    {s:'current', t:'Social Issues & Welfare'},
    {s:'current', t:'Sports, Awards & Persons'},
    {s:'current', t:'Reports, Indices & Rankings'},
    {s:'current', t:'UN & International Orgs'},
    {s:'current', t:'Important Days & Summits'},
    {s:'current', t:'GK Revision — All Subjects'},
    {s:'current', t:'Grand Revision — Prelims'},
  ];

  const SUBJECT_META = {
    history:     {label:'History',        icon:'📜', color:'#fbbf24'},
    geography:   {label:'Geography',      icon:'🌍', color:'#34d399'},
    polity:      {label:'Polity',         icon:'⚖️', color:'#60a5fa'},
    economy:     {label:'Economy',        icon:'💹', color:'#a78bfa'},
    science:     {label:'Science & Tech', icon:'🔬', color:'#fb7185'},
    environment: {label:'Environment',    icon:'🌿', color:'#4ade80'},
    current:     {label:'Current Affairs',icon:'📰', color:'#fb923c'},
  };

  const START    = new Date('2025-01-01T00:00:00');
  const TODAY    = new Date(); TODAY.setHours(0,0,0,0);
  const dayIndex = Math.max(0, Math.floor((TODAY - START) / 86400000));
  const todayDay = Math.min(dayIndex, SYLLABUS.length - 1);

  document.getElementById('tl-days-done').textContent  = Math.min(dayIndex + 1, SYLLABUS.length);
  document.getElementById('tl-total-days').textContent = SYLLABUS.length;
  document.getElementById('tl-fill').style.width = Math.min(100, Math.round(((dayIndex+1)/SYLLABUS.length)*100)) + '%';
  document.getElementById('tl-today-label').textContent = 'Day ' + (todayDay+1) + ' of ' + SYLLABUS.length;

  const container = document.getElementById('tl-nodes');
  let prevSubject = null;

  SYLLABUS.forEach(function(item, i) {
    const state = i < todayDay ? 'done' : i === todayDay ? 'today' : 'upcoming';
    const node  = document.createElement('div');
    node.className = 'tl-node ' + state;
    node.dataset.subject = item.s;
    node.dataset.index   = i;
    let segHtml = '';
    if (item.s !== prevSubject) {
      const m = SUBJECT_META[item.s];
      segHtml = '<div class="tl-segment-label">' + m.icon + ' ' + m.label + '</div>';
      prevSubject = item.s;
    }
    node.innerHTML = segHtml +
      '<div class="tl-dot"></div>' +
      '<div class="tl-node-label">' +
        '<div class="tl-node-day">Day ' + (i+1) + '</div>' +
        '<div class="tl-node-topic">' + item.t + '</div>' +
      '</div>';
    node.addEventListener('click', function(){ showCard(i); });
    container.appendChild(node);
  });

  function showCard(i) {
    const item  = SYLLABUS[i];
    const m     = SUBJECT_META[item.s];
    const card  = document.getElementById('tl-today-card');
    const state = i < todayDay ? '✅ Completed' : i === todayDay ? "📌 Today's DPP" : '🔒 Upcoming';
    document.getElementById('tl-today-day').textContent     = state + ' — Day ' + (i+1);
    document.getElementById('tl-today-topic').textContent   = item.t;
    document.getElementById('tl-today-subject').textContent = m.icon + ' ' + m.label;
    const link = document.getElementById('tl-today-link');
    link.textContent = i === todayDay ? "Practice Today's DPP →" : i < todayDay ? 'Review This DPP →' : 'View This DPP →';
    link.href = '/collections/' + item.s;
    card.style.display = 'block';
  }

  showCard(todayDay);

  setTimeout(function() {
    const wrapper  = document.querySelector('.tl-track-wrap');
    const todayNode = container.querySelectorAll('.tl-node')[todayDay];
    if (wrapper && todayNode) {
      wrapper.scrollTo({left: Math.max(0, todayNode.offsetLeft - wrapper.clientWidth/2 + 50), behavior:'smooth'});
    }
  }, 300);

  document.querySelectorAll('.tl-filter').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.tl-filter').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const subj = btn.dataset.subject;
      document.querySelectorAll('.tl-node').forEach(function(n){
        n.classList.toggle('hidden', subj !== 'all' && n.dataset.subject !== subj);
      });
      setTimeout(function(){
        const wrapper = document.querySelector('.tl-track-wrap');
        const vis = document.querySelector('.tl-node.today:not(.hidden)') || document.querySelector('.tl-node:not(.hidden)');
        if (wrapper && vis) wrapper.scrollTo({left: Math.max(0, vis.offsetLeft - wrapper.clientWidth/2), behavior:'smooth'});
      }, 100);
    });
  });

  const wrap = document.querySelector('.tl-track-wrap');
  let isDown=false, startX, scrollL;
  wrap.addEventListener('mousedown', function(e){ isDown=true; startX=e.pageX-wrap.offsetLeft; scrollL=wrap.scrollLeft; });
  wrap.addEventListener('mouseleave', function(){ isDown=false; });
  wrap.addEventListener('mouseup', function(){ isDown=false; });
  wrap.addEventListener('mousemove', function(e){ if(!isDown)return; e.preventDefault(); wrap.scrollLeft=scrollL-(e.pageX-wrap.offsetLeft-startX); });

})();